import { apiGet } from 'api';
import { GetFilterStatusesRequest, GetFilterStatusesResponse } from '../../types';

export const getFilterStatuses = (
  request?: GetFilterStatusesRequest
): Promise<GetFilterStatusesResponse> =>
  apiGet<GetFilterStatusesResponse, GetFilterStatusesRequest>('consultationstatuses', request);
